export default {"src":"/_next/static/media/ico_barcode.d1e1e308.svg","height":42,"width":44,"blurWidth":0,"blurHeight":0};